import { TextField } from "@mui/material";
import "./styles.css";

function TextFieldApp(props) {
  const {
    dimentions,
    listTXFL,
    formValues,
    handleChange,
    InputProps,
    InputLabelProps,
    textFieldStyle,
    disabled,
    labelFontSize,
    inputProps,
    className = "text_field",
  } = props;

  return (
    <div className="textHeader">
      {listTXFL.map((item) => (
        <>
          <div
            className={labelFontSize ? "personalDetailsLableCls" : "lableCls"}
            id={item.error ? "redlableColor" : ""}
          >
            {item.label}
          </div>
          <TextField
            error={item.error}
            helperText={item.helperText}
            sx={{ fontSize: "0.8rem", width: "100%" }}
            className={item.error ? "redborderColor" : "text_field"}
            key={item.label}
            style={textFieldStyle}
            variant="outlined"
            placeholder={item.plcHol}
            name={item.name}
            type={item.type}
            // margin="dense"
            disabled={disabled}
            value={
              item.name
                ? formValues && formValues[item.name]
                : formValues && formValues[item.type]
            }
            onChange={(e) => {
              handleChange(e);
            }}
            inputProps={inputProps}
            InputProps={InputProps}
            InputLabelProps={InputLabelProps}
          />
        </>
      ))}
    </div>
  );
}

export default TextFieldApp;
